// extracted by mini-css-extract-plugin
export var textInput = "_js-0";